export const UPDATE_EDITION = 'UPDATE_EDITION';

export function updateEdition (edition) {
    return {
        type: UPDATE_EDITION,
        edition,
    };
}
